export default __webpack_public_path__ + "static/media/banner-blog-1.d36b8ef3.png";